import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import AboutBreadcrumb from "../../components/AboutPage/AboutBreadcrumb/AboutBreadcrumb";
import featuredNewsData from "../../data/featuredNewsData";
import "./FeaturedNews.css";

const FeaturedNews = () => {
  return (
    <>
      <Header />
      <AboutBreadcrumb label="Featured News" />

      <section className="featured-news-section">
        <div className="featured-news-container">

          {featuredNewsData.map((item) => (
            <div className="news-card" key={item.id}>
              
              {/* LEFT IMAGE */}
              <div className="news-image">
                <img src={item.image} alt={item.title} />
              </div>

              {/* RIGHT CONTENT */}
              <div className="news-content">
                <span className="news-meta">
                  {item.date} &nbsp;&nbsp; {item.category}
                </span>

                <h3>{item.title}</h3>

                <p className="fade-in-text">
                  {item.description}
                </p>
              </div>

            </div>
          ))}

        </div>
      </section>

      <Footer />
    </>
  );
};

export default FeaturedNews;
